import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';

import { ContentRoute, LayoutSplashScreen } from '../../../_metronic/layout';
import { FunFacts } from './pages/FunFacts';

const Feed = () => {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<ContentRoute path='/fun-facts' component={FunFacts} />
			</Switch>
		</Suspense>
	);
};
export default Feed;
